import styled from 'styled-components';
import { Error } from '@styled-icons/boxicons-regular/Error';
import { Download } from '@styled-icons/fa-solid/Download';
import { Table } from '@styled-icons/fa-solid/Table';
import { Reload } from '@styled-icons/ionicons-sharp/Reload';
import { Button } from 'antd';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
`;

export const Wrapper = styled.div`
  display: flex;

  align-items: flex-end;
  margin-top: 1rem;

  & > button {
    width: 100%;
    max-width: 175px;
  }

  & > :nth-child(1) {
    max-width: 466px;
    margin-right: 1.5rem;
  }
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  & > .subtitle {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark2};
  }
  margin-bottom: 0.5rem;
`;

export const EmptyContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white4};
  height: calc(100vh - 24.5rem);
  padding-top: 2.5rem;
  text-align: center;

  & > h4 {
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1rem 0 2rem 0;
  padding: 1.5rem 1rem;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.white2};

  & > div {
    max-width: 24rem;
  }

  & > form {
    width: 25rem;
    display: flex;

    & .ant-form-item {
      width: 100%;
    }
  }
`;

export const DashboardContainer = styled.div`
  width: 100%;
  margin: 0;

  & > .bargraphs {
    & > :first-child {
      border-bottom: 0.09375rem solid
        ${({ theme }) => theme.colors.grayHefestoBorder};
      border-top: 0.09375rem solid
        ${({ theme }) => theme.colors.grayHefestoBorder};
    }
  }

  & > div.squared-charts {
    display: flex;
    flex-direction: row;
    background-color: ${({ theme }) => theme.colors.white};
    padding: 0rem 1.5rem;
    margin-top: 1.5rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.laptopM}) {
      flex-wrap: wrap;
    }
  }
`;

export const DashboardItemContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  min-height: 20rem;
  box-sizing: content-box;

  &.no-norder {
    border: none;
    padding: 0;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 1.5rem;
  }

  &.squared {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 20rem;
    height: 12rem;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
      /* width: unset;
            max-width: 29rem; */
    }

    &:not(:last-child) {
      @media (min-width: ${({ theme }) => theme.breakpoints.laptopM}) {
        margin-right: 1.5rem;
      }
    }
  }

  &.loading {
    padding: 1rem 0;
    flex-grow: 1;
  }

  // custom para tabela de openOrderStatus
  & .ant-table-content {
    & .ant-table-thead > tr > th.ant-table-cell {
      font-size: 0.875rem;
      color: ${({ theme }) => theme.colors.black};
      font-weight: 700;
    }
  }
`;

export const ItemContainerError = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > span {
    text-align: center;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  & > button.try-again {
    margin-top: 0.5rem;
  }
`;

export const DownloadIcon = styled(Download)`
  width: 1rem;
  color: ${({ theme }) => theme.colors.grayDark2};
  margin-right: 0.5rem;
`;

export const TableIcon = styled(Table)`
  width: 1rem;
  color: ${({ theme }) => theme.colors.grayDark2};
  margin-right: 0.5rem;
`;

export const ErrorIcon = styled(Error)`
  width: 2rem;
  color: ${({ theme }) => theme.colors.red};
  margin-bottom: 0.5rem;
`;

export const TryAgainIcon = styled(Reload)`
  width: 1rem;
  color: ${({ theme }) => theme.colors.blue3};
  margin-right: 0.5rem;
`;

export const DashboardCustomTableCell = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.black};
  word-break: break-word;

  &.total-row {
    font-size: 0.875rem;
    font-weight: 600;
    opacity: 0.8;
  }
`;

export const CleanFilterButton = styled(Button)`
  padding: 0;
  color: ${({ theme }) => theme.colors.grayDark};
  margin-left: 1rem;
  align-self: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-self: flex-end;
  }
`;

export const TitleContainer = styled.div`
  width: 100vw;
  margin: 0;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;

export const SubTitle = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  font-family: ${({ theme }) => theme.fonts.workSans};
  display: flex;
  justify-content: flex-start;

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;

export const SummaryContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem;

  &:first-child {
    padding: 1rem;
  }

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;

export const SummaryContainerCell = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;

  & > div {
    padding-right: 4.5rem;
  }
`;

export const SummaryTableContainer = styled.div`
  width: 98vw;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 0.25rem;
  margin: 1rem auto;
  margin-left: 0.6rem;

  & > .hefesto-title {
    margin-bottom: 1.5rem;
  }
`;

export const DashboardGraphHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & .data-picker {
    width: 10.75rem;
  }

  & .actions__container {
    width: 17.625rem;
  }
  & .actions {
    display: flex;
    align-items: center;
    column-gap: 1rem;

    & button:first-child {
      width: 6.125rem;
    }
    & button:nth-child(2) {
      width: 10.5rem;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: wrap;
  }
`;

export const BarGraphContainer = styled.div`
  box-sizing: border-box;
  height: 31.25rem;
  width: 100%;
`;
